/* eslint-disable jsx-a11y/anchor-is-valid */
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Link from 'next/link';
import styles from '../navigation.module.scss';
import MenuItem from './MenuItem';
import trackHeapEvent from '../../../../services/helpers/trackHeapEvent';

export default function Menu({ column = [], hideTitles = false }) {
  const quickLinktHeapTrack = (heapEventKey) => {
    trackHeapEvent(
      { Name: 'Global Nav Footer', CTA: heapEventKey },
      'CMS_Unification'
    );
  };

  return (
    column?.length > 0 &&
    column?.map((menu, index) => {
      const key = `menu-${index}`;
      return (
        !menu?.description && (
          <nav key={key} className={styles.menu} aria-labelledby="menu offer">
            {!hideTitles &&
              (menu?.link ? (
                <h2 className={styles.title}>
                  {menu?.title && (
                    <Link
                      href={menu.link}
                      data-testid={menu.title}
                      onClick={() => quickLinktHeapTrack(menu?.analyticsKey)}
                    >
                      {parse(`${menu.title}`)}
                    </Link>
                  )}
                </h2>
              ) : (
                menu?.title && (
                  <h2 className={styles.title} data-testid={menu.title}>
                    {parse(`${menu.title}`)}
                  </h2>
                )
              ))}
            {menu?.items && <MenuItem items={menu.items} />}
          </nav>
        )
      );
    })
  );
}

Menu.propTypes = {
  column: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      link: PropTypes.string,
      items: PropTypes.array,
    })
  ),
  hideTitles: PropTypes.bool,
};
